import { createSelector } from 'reselect'
import { IEquipmentState } from 'apps/fleet-planner/utils/types/equipment'
import { IStore } from 'apps/fleet-planner/utils/types/store'

export const selectEquipmentState = ({ equipment }: IStore): IEquipmentState => equipment
export const selectTrailers = createSelector(selectEquipmentState, res => res.trailers)
export const selectTrucks = createSelector(selectEquipmentState, res => res.trucks)
